import { render, staticRenderFns } from "./FormViewModal.vue?vue&type=template&id=0bcef0be"
import script from "./FormViewModal.vue?vue&type=script&lang=js"
export * from "./FormViewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports